// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"663":"059df29613a413e8","806":"902c4cc2eb0b8b7b","904":"12ccc1ffc3e7005b"}[chunkId] + ".js";
};